<template>
    <div class="prelative">
        <preloader :display="loader" class="loader-small"/>
        <toggle-card :display="!loader" :data="cardDatas"/>
    </div>
</template>


<script>
    import ToggleCard from './ToggleCard.vue';
    import Preloader from "vcomponents/utilities/Preloader.vue";

    export default {
        props: {
            //url used to fetch the data. use it or use controller/action props
            endpoint: {
                type: String,
                required: false
            },
            // controller called to fetch the data
            controller:{
                type: String
            }, 
            // action called to fetch the data
            action: {
                type: String,
            }, 
            // Linkedtype of the card (ex : staff)
            linkedtype: {
                type: String,
                default: 'staff'
            }, 
            // Linkedid of the card (ex : 3898 => staffid)
            linkedid: {
                type: Number
            },
            // Type of the card (ex : contact, support, opportunity)
            cardtype: {
                type: String
            },
        },
        data: function(){
            return {
                cardDatas : {},
                loader : true,
            }
        },
        created(){
            this.getDatas();
        },
        methods: {
            // @vuese
            // Ajax call to fetch the data for the card
            getDatas(){
                var props   = this._props;
                var self    = this;

                var options = {
                    'id'        : props.linkedid,
                    'cardtype'  : props.cardtype
                };

                if (props.endpoint) {
                    $.get(`${props.endpoint}/${props.cardtype}/${props.linkedid}`, {}, function( data ) {
                        self.cardDatas = data.datas;
                        self.loader = false;
                    }, "json" );
                } else {
                    $.post(`/?_f=${props.controller}&action=${props.action}`, options , function( data ) {
                        self.cardDatas = data.datas;
                        self.loader = false;
                    }, "json" );
                }

            }
        },
        components: {
            Preloader,
            'toggle-card' : ToggleCard
        }
    }
</script>


<style lang="scss" scoped>
    .card {
        margin-bottom : 16px;
    }
</style>
